import { render, staticRenderFns } from "./AssembleModal.vue?vue&type=template&id=fa5ae0a8&scoped=true"
import script from "./AssembleModal.vue?vue&type=script&lang=js"
export * from "./AssembleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@7.1.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5ae0a8",
  null
  
)

export default component.exports